var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",class:{
    header__blue: _vm.theme == 'blue',
    header__white: _vm.theme == 'white',
    header__left: _vm.left == true,
    header__arrow: _vm.arrow == true,
  }},[_c('p',{staticClass:"header__text"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }